var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmeetGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_18328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_18328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 13.3332C2.29967 13.3332 1.9859 13.2027 1.72501 12.9418C1.46367 12.6805 1.33301 12.3665 1.33301 11.9998V3.99984C1.33301 3.63317 1.46367 3.31939 1.72501 3.0585C1.9859 2.79717 2.29967 2.6665 2.66634 2.6665H10.6663C11.033 2.6665 11.347 2.79717 11.6083 3.0585C11.8692 3.31939 11.9997 3.63317 11.9997 3.99984V6.99984L14.6663 4.33317V11.6665L11.9997 8.99984V11.9998C11.9997 12.3665 11.8692 12.6805 11.6083 12.9418C11.347 13.2027 11.033 13.3332 10.6663 13.3332H2.66634ZM2.66634 11.9998H10.6663V3.99984H2.66634V11.9998Z",
    fill: "#969696"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeetGrey);
export default __webpack_public_path__ + "static/media/gmeet_grey.987526e28e445343b80c92ab1e26e114.svg";
export { ForwardRef as ReactComponent };